import VideoJS from 'video.js';

import * as Controls from '../../ui/UIControlsNames';
import closeSVG from '../../ui/icons/close.svg';

const CloseButton = VideoJS.getComponent('CloseButton');

class ASCloseButton extends CloseButton {
    createEl() {
        const el = super.createEl(...arguments);

        const closeIcon = VideoJS.dom.createEl('span', {
            innerHTML: closeSVG,
            className: 'vjs-icon vjs-icon--close',
        }, {
            'aria-hidden': 'true'
        });

        el.appendChild(closeIcon);

        return el;
    }

    buildCSSClass() {
        return `as-close-button ${super.buildCSSClass()}`;
    }
}

VideoJS.registerComponent(Controls.CLOSE_BUTTON, ASCloseButton);

export default ASCloseButton;



// WEBPACK FOOTER //
// ./src/player/components/ASCloseButton.js